// extracted by mini-css-extract-plugin
export default {"control":"KB4XiL","root":"tHb09N","webinarMessage":"mCGTng","noDevices":"INNUoL","link":"buV4Ft"};